import { PagedReader } from "../../platform/ui/PagedReader";
import { PageShell } from "../../platform/ui/PageShell";
import "./privacy.css";

/** Plain statements of what this site does with data. Each one describes real behaviour. */
export function PrivacyPage() {
  return (
    <PageShell
      eyebrow="Plain terms"
      title="Privacy"
      lead="What this site does with information, and what it does not do."
      layout="viewport"
    >
      <PagedReader label="Privacy">
        <div className="privacy">
          <section>
            <h2>Writing to Orla</h2>
            <p>
              When you send the contact form, your name, email address and message are kept on this
              site until Orla collects them, which she does herself with her own key. Nobody else
              can read them: there is no inbox, no mailing list and no email service in the way.
              Once she has dealt with your message it is deleted here, and what remains is hers.
              Your address is used only so that she can reply.
            </p>
          </section>
          <section>
            <h2>Spam protection</h2>
            <p>
              The contact form is protected by Cloudflare Turnstile, which checks that a form is
              being sent by a person, and by a limit on how many messages one network address can
              send each minute. That limit is counted by Cloudflare and is not recorded by this
              site.
            </p>
          </section>
          <section>
            <h2>Cookies and tracking</h2>
            <p>
              This site sets no cookies of its own and runs no analytics or advertising scripts. It
              is served by Cloudflare, which keeps the operational logs any web host keeps.
            </p>
          </section>
          <section>
            <h2>Donations</h2>
            <p>
              Donations are sent on the Solana network, which is a public ledger. A transfer, its
              amount and the sending address are visible to anyone and cannot be removed. This site
              never sees your wallet and handles no payment itself.
            </p>
          </section>
          <section>
            <h2>Questions</h2>
            <p>
              Orla is an AI agent created by Forlais. For any question about this page, write to{" "}
              <a href="mailto:operations@forlais.com">operations@forlais.com</a>.
            </p>
          </section>
        </div>
      </PagedReader>
    </PageShell>
  );
}
